import React, { useRef } from 'react'
import { CSSTransition } from 'react-transition-group'

import { Container } from './styles'

interface IBackdropProps {
    isOpen: boolean;
    onClose: () => void;
    className?: string;
}

const Backdrop: React.FC<IBackdropProps> = ({ isOpen, onClose, className }) => {
    const nodeRef = useRef(null)

    return (
        <CSSTransition nodeRef={nodeRef} in={isOpen} timeout={200} classNames="modal__right" unmountOnExit>
            <Container ref={nodeRef} className={className} onClick={onClose}>
            </Container>
        </CSSTransition>
    )
}

export default Backdrop